import { Box, Button, Segmented } from '@grovus/design-system'
import { LANG_OPTIONS, type Dict, type Lang } from '../i18n'
import { PanelHeading } from './PanelHeading'

interface Props {
  t: Dict
  lang: Lang
  setLang: (l: Lang) => void
  theme: 'light' | 'dark'
  toggleTheme: () => void
  onSignOut: () => void
  signOutPending: boolean
}

const SECTION = { borderTop: '1px solid var(--mantine-color-default-border)' }

/**
 * The session settings: language and palette, then sign-out. Set once, rarely touched and
 * never needed to read a figure, so they live in the user menu at every width (GRO-66) and
 * render as its last two sections. App builds the block; the user menu places it.
 */
export function SessionSettings({
  t, lang, setLang, theme, toggleTheme, onSignOut, signOutPending,
}: Props) {
  return (
    <>
      <Box pt="sm" mt="sm" style={SECTION}>
        <PanelHeading>{t.settingsLead}</PanelHeading>
        <div className="session-settings">
          <Segmented
            data-testid="lang-control"
            value={lang}
            onChange={(value) => setLang(value as Lang)}
            data={LANG_OPTIONS}
          />

          <Button variant="default" onClick={toggleTheme} data-testid="theme-toggle">
            {theme === 'light' ? t.dark : t.light}
          </Button>
        </div>
      </Box>

      <Box pt="sm" mt="sm" style={SECTION}>
        <Button variant="default" onClick={onSignOut} disabled={signOutPending} data-testid="sign-out-button">
          {t.signOut}
        </Button>
      </Box>
    </>
  )
}
